import { deleteAlerts as callDeleteAlerts } from '../../api/alerts/deleteAlerts';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listAlerts } from './alertsModule';
import { t } from '../../i18n';

const deleteAlertsModule = createApiModule({
  name: 'deleteAlerts',
  apiMethod: callDeleteAlerts,
  parse: (response) => response.data,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_ALERTAS_ELIMINADAS'),
    }),
    listAlerts({ page: 1, size: 10 }),
  ],
  onError: () => ({
    message: t('StoreAlertsDeleteAlertsModuleNoHemosPodidoBorrarLasAlertas'),
  }),
  onValidationError: () => ({
    message: t('StoreAlertsDeleteAlertsModuleNoHemosPodidoBorrarLasAlertas'),
  }),
});

export const {
  start: deleteAlerts,
  success: deleteAlertsOk,
  error: deleteAlertsKo,
} = deleteAlertsModule.slice.actions;

export const { sagas } = deleteAlertsModule;

export default deleteAlertsModule;
